// extracted by mini-css-extract-plugin
export default {"button":"NavTabItem_button__OxNG+","active":"NavTabItem_active__P7KlN"};